import { Col, Container, Row } from "react-bootstrap";
import CartItem from "../../Components/Cart/CartItem";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { storeNotLoginCartItems } from "../../redux/actions/cartAction";
import CartCheckout from "../../Components/Cart/CartCheckout";
import calculatePriceForProductItem from "../../helpers/calculatePriceForProductItem";
import { Navigate, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// notLoginCartItems
export default function NotLoginCartPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const settings = useSelector((state) => state.settingsReducers.settings);
  var user = null;
  if (localStorage.getItem("user") != null) {
    user = JSON.parse(localStorage.getItem("user"));
  }



  // const[totalPrice]=useState(0);

  useEffect(() => {
    let cartItems = JSON.parse(localStorage.getItem("cart"));

    dispatch(storeNotLoginCartItems({ items: cartItems }));
  }, []);

  
  
  const itemsToShow = useSelector(
    (state) => state.cartReducer.notLoginCartItems
  );

  console.log("itemsToShow", itemsToShow);
  let totalPrice = 0;

  itemsToShow?.map((el) => {
    if (el?.product?.Offer) {
      let itemPrice;
      let priceOffer=calculatePriceForProductItem(el?.product);
      console.log('priceOffer',priceOffer);
     
       totalPrice += priceOffer * el?.quantity;
    } 
    else {
      console.log("el?.product?.priceBefore", el?.product?.price1);
      console.log("el?.quantity", el?.quantity);

      totalPrice += el?.product?.price1 * el?.quantity;
    }
  });

  console.log("totalPrice", totalPrice);

    if (user == null && !settings?.data?.hasNotLoginCart) {
      navigate("/");
   console.log('mmmmmmmmmmmmmmmmmeeeeeeee')
      return;
    }


  return (
    <Container style={{ minHeight: "670px" }}>
      <Row>
<div className="cart-title mt-4">{t("shopping cart")}</div>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs="12" md="9">
          {itemsToShow?.length >= 1 ? (
            itemsToShow.map((item,i) => {
              return <CartItem key={i} item={item} />;
            })
          ) : (
            <h6>{t("no products in cart")}</h6>
          )}
        </Col>

        <Col xs="12" md="3">
          {itemsToShow?.length > 0 && (
            <CartCheckout
              cartItems={itemsToShow}
              // couponNameAfterApplay={couponNameAfterApplay}
              // totalPriceAfterDiscount={Number(totalPriceAfterDiscount).toFixed(2)}
              totalPrice={totalPrice.toFixed(2)}
              // totalShippingCost={shippingCost}
              // vendorId={vendorId}
              loginCart={false}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
}
